import { render, staticRenderFns } from "./errorsLDS.vue?vue&type=template&id=759140ae&scoped=true"
import script from "./errorsLDS.vue?vue&type=script&lang=js"
export * from "./errorsLDS.vue?vue&type=script&lang=js"
import style0 from "./errorsLDS.vue?vue&type=style&index=0&id=759140ae&prod&lang=css"
import style1 from "./errorsLDS.vue?vue&type=style&index=1&id=759140ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "759140ae",
  null
  
)

export default component.exports